export const cloneControl = {
  defaultButton: `Klonen`,
  defaultNoun: `Einstellungen`,
  itemNounDefault: `diese Einstellungen`,
  pullTitle: `Einstellungen aus einem anderen Inserat übernehmen`,
  pushTitle: `Diese Einstellungen in ein anderes Inserat kopieren`,
  pullSubReplace: `Sie werden auf dieses Inserat angewendet`,
  pullSubAdd: `Sie werden zu diesem Inserat hinzugefügt`,
  pushSubReplace: `Sie werden auf die ausgewählten Inserate angewendet`,
  pushSubAdd: `Sie werden zu den ausgewählten Inseraten hinzugefügt`,
  pullTitleFull: `{noun} übernehmen`,
  pushTitleFull: `{noun} kopieren`,
  pullSubtitle: `Wählen Sie das Inserat, aus dem die Einstellungen übernommen werden. Sie werden auf dieses angewendet.`,
  pushSubtitle: `Kopieren Sie diese Einstellungen in die von Ihnen ausgewählten Inserate.`,
};
